export function makeSlug(origin: string): string {
    let slug = '';
    const trimmed = origin.trim();
    slug = trimmed.replace(/[^a-z0-9-]/gi, '-').
        replace(/-+/g, '-').
        replace(/^-|-$/g, '');
    return slug.toLowerCase();
}
